import { ArrowLeftOutlined, CaretDownOutlined, CheckCircleFilled, DeleteOutlined, DownOutlined, EyeOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons"
import { Breadcrumb, Button, Form, Input, message, Select, Upload, UploadProps } from "antd"
import { useForm } from "antd/es/form/Form"
import { useEffect, useMemo, useRef, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { getSlListCustomerFieldsV2, getSLParameters, getSLTemplate, ISelectOption, ISelectOptionMentions, ISLCustomerFields } from "../../api/selectOptions/selectOptionsApi"
import useLoading from "../../hook/useLoading"
import useToast from "../../hook/useToast"
import Layout from "../../Layout"
import { CHANNELTYPE } from "../../services/data"
import { buildOptionsV2, fommatSelectOption } from "../../until"
import './NotificationEmailCreate.scss'
import { formatSelectOptionMentions } from "./NotificationSMSCreate"

import { CopyOutlined } from "@ant-design/icons";

import "jodit/es2021/jodit.min.css"
import { addNotificationTemplate, getListBrandNames, IBrandConfigs } from "../../api/notificationTemplate/notificationTemplateApi"
import JoditWithMentions from "../../components/JoditWithMentions"
import useDebounce from "../../hook/useDebounce"
import { OptionData } from "../CustomersV2/indexV2"

const { Dragger } = Upload;
const props: UploadProps = {
  name: "file",
  multiple: false,
  action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
  onChange(info) {
    const { status } = info.file;
    if (status !== "uploading") {
    }
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  },
};






const NotificationEmailCreate: React.FC = () => {
  useEffect(() => {
    gSLParameters()
    gListBrandNames()
    gSlListCustomerFieldsV2()
  }, []);

  const [form] = useForm()
  const navigate = useNavigate()
  const location = useLocation();
  const { type: typeState } = location?.state ?? {}
  useEffect(() => {
    const formData = location.state?.formData;

    if (formData) {
      form.setFieldsValue(formData);

      setContentCkeditor(formData.content || "");
    }
  }, []);

  const variables = Form.useWatch("variables", form)


  const pushToast = useToast();
  const pushLoading = useLoading()
  const brandNameIds = Form.useWatch("brandNameIds", form) || []

  const [openCollapse, setOpenCollapse] = useState<boolean>(true)

  const selectedIds = useMemo(
    () => brandNameIds.map((i: any) => i?.brandName).filter(Boolean),
    [brandNameIds]
  );

  const [inputChange, setInputChange] = useState<String>("");
  // const [content, setContent] = useState<String>("");
  const [sLTemplate, setSLTemplate] = useState<ISLCustomerFields[]>([])
  const [searchText, setSearchText] = useState('');


  const [openMap, setOpenMap] = useState<boolean>();
  const [expandMap, setExpandMap] = useState<string[]>([]);

  const [sLParameters, setSLParameters] = useState<ISelectOptionMentions[]>([])

  const editor = useRef(null);
  const [listBrandConfigs, setListBrandConfigs] = useState<IBrandConfigs[]>([])
  const [searchTemplate, setSearchTemplate] = useState<string>('')

  const [selectValue, setSelectValue] = useState<number | undefined>(undefined)
  const [contentCkeditor, setContentCkeditor] = useState(`
    <h2>Xin chào!</h2>
    <p>Đây là nội dung email mẫu.</p>
    <p>
      Bạn có thể chỉnh sửa như Word:
      <strong>in đậm</strong>,
      <em>in nghiêng</em>,
      <u>gạch chân</u>.
    </p>
  `);

  const gListBrandNames = async () => {
    pushLoading(true)
    const result = await getListBrandNames(CHANNELTYPE.EMAIL)
    if (result?.status) {
      setListBrandConfigs(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }


  const getOptions = (currentId?: number) => {
    return listBrandConfigs
      .filter(b => !selectedIds.includes(b.id) || b.id === currentId)
      .map(b => ({
        label: b.brandName,
        value: b.id
      }))
  }

  const handleSelectBrand = (value: number, index: number) => {
    const brand = listBrandConfigs.find(b => b.id === value)

    if (!brand) return

    const current = form.getFieldValue("brandNameIds") || []

    current[index] = {
      ...current[index],
      brandName: value,
      categoryCarIds: brand.categories
    }

    form.setFieldsValue({
      brandNameIds: current
    })
  }


  // const gSLTemplate = async () => {
  //   pushLoading(true)
  //   const result = await getSlListCustomerFieldsV2()
  //   if (result?.status) {
  //     setSLTemplate(fommatSelectOption(result.data))
  //   }
  //   pushLoading(false)
  // }


  const gSlListCustomerFieldsV2 = useDebounce(async () => {
    pushLoading(true)
    const result = await getSlListCustomerFieldsV2(undefined, undefined, searchTemplate
    )
    if (result?.status) {
      setSLTemplate(result.data)
    }
    pushLoading(false)
  }, 1000)

  // hàm xử lý select trường V2
  const options = useMemo(() => buildOptionsV2(sLTemplate), [sLTemplate]);

  const selectableOptions = options.filter(
    (item) => !item.isGroup
  );
  // end





  const toggleGroup = (groupKey: string) => {
    setExpandMap((prev) =>
      prev.includes(groupKey)
        ? prev.filter((k) => k !== groupKey)
        : [...prev, groupKey]
    );
  };


  const gSLParameters = async () => {
    pushLoading(true)
    const result = await getSLParameters()
    if (result?.status) {
      setSLParameters(formatSelectOptionMentions(result.data))
    }
    pushLoading(false)
  }

  const onFinish = async (values: any) => {
    const { title, titleEmail, brandNameIds, content } = values ?? {}

    const brandNameIdsTmp = brandNameIds?.map((item: any) => item.brandName)
    pushLoading(true)
    const result = await addNotificationTemplate(
      title, content, CHANNELTYPE.EMAIL, brandNameIdsTmp,
      titleEmail
    )
    if (result.status) {
      pushToast(result.message, 'success', 2000)
      navigate('/marketing/notification-templates-management', {
        state: {
          type: typeState ?? CHANNELTYPE.EMAIL
        }
      })
    } else {
      pushToast(result.message, 'error', 2000)

    }
    pushLoading(false)
  };


  useEffect(() => {
    gSlListCustomerFieldsV2()
  }, [searchTemplate])
  return (
    <Layout>
      <div className="app-breadcrumb-block">
        <Breadcrumb
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/marketing/notification-templates-management">Marketing</Link>, },
            { title: <Link to="/marketing/notification-templates-management">Quản lý mẫu thông báo</Link>, },
            { title: 'Tạo nội dung mẫu Email', },
          ]}
        />
        <Form
          className="custom-page-css flex flex-col flex-3 gap-3"
          initialValues={{
            remember: true,
            brandConfigs: [
              {
                categoryCarIds: [],
                brandName: undefined
              }
            ]
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          form={form}
        >
          <div className="d-flex align-baseline gap-3">
            <div className="app-breadcrumb-title">
              <div className="cursor-pointer" onClick={() => navigate('/marketing/notification-templates-management', { state: { type: typeState ?? CHANNELTYPE.EMAIL } })}><ArrowLeftOutlined /></div>
              <div className="title">Nhập mẫu mới </div>
            </div>
            <p className="text-sm font-regular text-98A2B3">
              Tạo nội dung mẫu Email
            </p>
          </div>
          <div className="d-flex justify-center">
            <div className="w-769-px d-flex flex-column gap-6">
              <div className="d-flex gap-6 pt-6">
                <div className="w-full">
                  <Form.Item
                    name="title"
                    rules={[{ required: true, message: 'Tên mẫu không được để trống!' }]}
                  >
                    <Input
                      placeholder="Nhập tên mẫu, ví dụ: Mẫu chào sản phẩm mới"
                      className="custom-input-css custom-page-css"
                    />
                  </Form.Item>
                </div>
                <button className="custom-page-css flex items-center justify-center bg-096DD9 rounded gap-10-px  border-1890FF shadow-btn-save px-15-px white-space-nowrap">
                  <SaveOutlined className="text-sm text-white" />
                  <span className="text-sm font-regular text-white">Lưu mẫu </span>
                </button>
              </div>
              <div className="d-flex flex-column gap-4">

                <div className="d-flex justify-between align-center">
                  <p className="text-base fw-600 font-bold text-344054">Tiêu đề Email</p>
                  <div className="w-250-px">
                    <Form.Item
                      name="variables"
                      className="m-none-form-item text-explan"
                    >
                      {/* <Select
                        placeholder="Tham số"
                        className="custome-select-t custom-page-css border rounded overflow-hidden"
                        options={sLTemplate}

                      /> */}
                      <Select
                        showSearch
                        onSearch={(value) => {
                          setSearchText(value);
                          setSearchTemplate(value);
                        }}
                        value={selectValue}
                        open={openMap}
                        onDropdownVisibleChange={(open) => {
                          setOpenMap(open);
                          if (!open) {
                            setSearchText('');
                            setSearchTemplate('')
                          }
                        }}
                        onChange={(value) => {
                          setSelectValue(value);
                        }}
                        placeholder="Tham số"
                        // style={{ width: 320 }}
                        optionFilterProp="label"
                        options={selectableOptions}
                        filterOption={false}

                        dropdownRender={() => (
                          <div
                            style={{
                              maxHeight: 350,
                              overflowY: "auto",
                            }}
                          >
                            {options.filter((item) => {
                              if (!searchText) return true;
                              const keyword = searchText.toLowerCase();
                              if (item.isGroup) {
                                // Giữ group nếu có child khớp
                                return options.some(
                                  (o) => !o.isGroup && o.parentKey === item.key && o.label.toLowerCase().includes(keyword)
                                );
                              }
                              return item.label.toLowerCase().includes(keyword);
                            }).map((item) => {
                              if (item.isGroup) {


                                return (
                                  <div
                                    key={item.key}
                                    onClick={() => toggleGroup(item.key)}
                                    style={{
                                      padding: "8px 12px",
                                      fontWeight: 600,
                                      background: "#fafafa",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                    }}
                                  >
                                    <CaretDownOutlined
                                      rotate={expandMap.includes(item.key) ? 0 : -90}
                                    />
                                    {item.title}
                                  </div>
                                );
                              }

                              const groupKey = item.parentKey;
                              if (groupKey && !expandMap.includes(groupKey)) {
                                return null;
                              }

                              return (
                                <div
                                  key={item.key}
                                  onMouseDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  // onClick={() => {
                                  //     console.log(i, item)
                                  //     setValue(item.value); // chọn value
                                  //     handleChangeField(i, item);
                                  //     setOpen(false);       // đóng dropdown
                                  // }}
                                  className="custom-page-css flex justify-between items-center gap-2 items-option"
                                  onClick={() => {
                                    // handleChangeField(i, item);
                                    setSelectValue(item.value);

                                    form.setFieldValue("variables", item.value);

                                    setOpenMap(false);
                                  }}
                                  style={{
                                    padding: "8px 32px",
                                    cursor: "pointer",

                                  }}
                                >
                                  {item.label} {`{${item?.fieldCode}}`}
                                  <CopyOutlined
                                    style={{
                                      color: '#096DD9'
                                    }}
                                    onClick={async (e) => {
                                      e.stopPropagation();

                                      const textToCopy = `{{${item.fieldCode}}}`;

                                      await navigator.clipboard.writeText(textToCopy);

                                      message.success("Đã copy");
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        )}
                      />
                    </Form.Item>

                  </div>

                </div>
                <div className="w-full ">
                  <Form.Item
                    name="titleEmail"
                    rules={[{ required: true, message: 'Tiêu đề Email không được để trống!' }]}
                  >
                    <Input
                      placeholder="Nhập tiêu đề Email, ví dụ: Bất ngờ chưa? THACO AUTO đang có chương trình..."
                      className="custom-input-css custom-page-css"
                      onChange={(e) => setInputChange(e.target.value)}
                    />
                  </Form.Item>

                </div>
                <div
                  className={`${inputChange ? `w-full rounded custom-page-css d-flex align-center h-10 gap-10-px px-10-px ${inputChange.length >= 56 ? ' bg-F6FEF9 border-039855 ' : 'border-FA541C bg-FFF0F6'}` : 'none'}`}
                >
                  <CheckCircleFilled className={`text-sm ${inputChange.length >= 56 ? ' text-039855' : 'text-FA541C'}`} />
                  <p className="text-sm font-regular text-344054">Độ dài tiêu đề {inputChange.length} ký tự {inputChange.length >= 56 ? "rất phù hợp" : "không phù hợp"}
                    <span className="text-sm font-regular text-98A2B3">(trong khoảng 50 - 60 ký tự)</span></p>
                </div>
              </div>

              {/* <div className="custom-page-css flex flex-col gap-3">
                <div className="custom-page-css flex items-center gap-3 text-base text-344054 font-medium cursor-pointer"
                  onClick={() => setOpenCollapse(!openCollapse)}
                >
                  Thiết lập tên email để gửi tin
                  <DownOutlined style={{ rotate: openCollapse ? '180deg' : '0deg' }} />
                </div>
                <div className={openCollapse ? 'block' : 'hidden'}>
                  <Form.List
                    name="brandNameIds"
                  >
                    {(fields, { add, remove }) => (
                      <div className={` custom-page-css flex flex-col gap-4`}
                      >

                        {fields.map(({ key, name, ...restField }, index) => (
                          <div
                            key={key}
                            className="custom-page-css grid grid-cols-1fr_1fr_auto gap-4 items-end"
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "brandName"]}
                              label="Tên email"
                              rules={[{ required: true, message: "Chọn tên email" }]}
                            >
                              <Select
                                placeholder="Tên email"
                                className='custom-page-css border rounded overflow-hidden'
                                options={getOptions(
                                  form.getFieldValue(["brandNameIds", name, "brandName"])
                                )}
                                onChange={(value) => handleSelectBrand(value, name)}
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "categoryCarIds"]}
                              label="Thương hiệu hãng xe"
                            >
                              <Input
                                placeholder="Thương hiệu hãng xe"
                                className='custom-page-css border rounded overflow-hidden'
                                disabled
                              />
                            </Form.Item>

                            <Button
                              danger
                              disabled={fields.length === 1}
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            />

                          </div>
                        ))}

                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() =>
                            add({
                              categoryCarIds: undefined,
                              brandName: undefined
                            })
                          }
                          className="w-fit"
                        >
                          Thêm tên email
                        </Button>

                      </div>
                    )}
                  </Form.List>
                </div>
              </div> */}


              <Form.Item
                name="content"
                rules={[
                  {
                    required: true,
                    message: "Nội dung không được để trống!",
                  },
                ]}
                className="t-mb-16"
              >
                <JoditWithMentions
                  value={contentCkeditor}
                  options={sLParameters}
                  onChange={(html: any) => {
                    setContentCkeditor(html);
                    form.setFieldValue("content", html);
                  }}
                />
              </Form.Item>

              <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
                <div className=" d-flex justify-center w-full">

                  <Button type="primary" disabled={!contentCkeditor} htmlType="button" className="custom-page-css text-white text-base fw-600 font-bold rounded h-38-px flex items-center gap-10-px px-4"

                    onClick={() =>
                      navigate(`/marketing/notification-templates-management/previewemail`,
                        {
                          state: {
                            formData: {
                              ...form.getFieldsValue(),
                              content: contentCkeditor,
                            },
                          }
                        })
                    }
                  >
                    <EyeOutlined className="text-sm" />
                    Xem thử nội dung gửi đi
                  </Button>

                </div>
              </div>
            </div>

          </div>
        </Form>
      </div >

    </Layout >
  )
}
export default NotificationEmailCreate
